import { Button } from '@platform/components';

const EmptyMyProjectsTabContent = ({
  tabKey,
  userType,
  blockSearch = false,
}: {
  tabKey: string;
  userType: 'pro' | 'rep';
  blockSearch?: boolean;
}) => {
  const content = getEmptyTabContent(tabKey, userType, blockSearch);
  return (
    <div className='text-display-xs text-center h-full mt-24 flex flex-col gap-10 items-center'>
      {content}
    </div>
  );
};

const BrowseProjectsButton = () => (
  <Button variant='primary' size='md' href={`/platform/project-search`}>
    Browse Projects
  </Button>
);
const CreateProjectButton = () => (
  <Button variant='primary' size='md' href='/platform/create-project'>
    Create a project
  </Button>
);

const getEmptyTabContent = (tabKey: string, userType: 'pro' | 'rep', blockSearch: boolean) => {
  if (userType === 'pro') {
    switch (tabKey) {
      case 'In Progress':
        return (
          <>
            <div>You don't have any sent introductions waiting for a response at this time.</div>
            {!blockSearch && (
              <div>Get started by sending introductions to projects that match your skills.</div>
            )}
            {!blockSearch && <BrowseProjectsButton />}
          </>
        );
      case 'Inactive':
        return (
          <div>
            You don't have any expired introductions, declined introductions, or completed projects.
          </div>
        );
      case 'Saved':
        return (
          <>
            <div>You haven't saved any projects yet.</div>
            {!blockSearch && (
              <div>Browse available projects and save your favorites to view them later.</div>
            )}
            {!blockSearch && <BrowseProjectsButton />}
          </>
        );
      default:
        throw new Error(`Unknown pro user tab key: ${tabKey}`);
    }
  } else if (userType === 'rep') {
    switch (tabKey) {
      case 'Active projects':
        return (
          <>
            <div>You don't have any projects yet!</div>
            <div>
              Create your first one to start connecting with skilled professionals who can help.
            </div>
            <CreateProjectButton />
          </>
        );
      case 'Inactive projects':
        return (
          <>
            <div>You don't have any inactive projects or introductions.</div>
            <CreateProjectButton />
          </>
        );
      default:
        throw new Error(`Unknown rep user tab key: ${tabKey}`);
    }
  }
};

export default EmptyMyProjectsTabContent;
